import React, { useState, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import {
  Divider,
} from 'antd';

import CustomExportFilterDropdownFooter from './CustomExportFilterDropdownFooter';
import OnTraccrTextInput from '../../common/inputs/OnTraccrTextInput';
import OnTraccrNumberInput from '../../common/inputs/OnTraccrNumberInput';

export default function CustomExportNumberRangeFilterDropdown({
  clearFilters,
  confirm,
  selectedKeys,
  setSelectedKeys,
  visible,
}) {
  const [min, setMin] = useState(null);
  const [max, setMax] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [prevSelectedKeys, setPrevSelectedKeys] = useState(selectedKeys);

  const onMinChange = (value) => {
    setMin(value ?? null);
  };
  const onMaxChange = (value) => {
    setMax(value ?? null);
  };
  const onSearchTextChange = (e) => {
    setSearchText(e?.target?.value ?? '');
  };

  const applyFilter = useCallback(() => {
    const searchTrim = searchText.trim();
    if (min == null && max == null && !searchTrim) {
      setSelectedKeys([]);
      clearFilters();
    } else {
      setSelectedKeys([{
        min,
        max,
        searchText: searchTrim || undefined,
      }]);
    }
    confirm();
  }, [min, max, searchText, setSelectedKeys, clearFilters, confirm]);

  const reset = useCallback(() => {
    setMin(null);
    setMax(null);
    setSearchText('');
    setSelectedKeys([]);
    clearFilters();
    confirm();
  }, [setSelectedKeys, clearFilters, confirm]);

  if (visible && selectedKeys !== prevSelectedKeys) {
    setPrevSelectedKeys(selectedKeys);
    const filter = selectedKeys?.[0];
    if (filter) {
      const parseFilterNumber = (value) => {
        if (value == null || value === '') return null;
        const parsed = Number(value);
        return Number.isNaN(parsed) ? null : parsed;
      };
      setMin(parseFilterNumber(filter.min));
      setMax(parseFilterNumber(filter.max));
      setSearchText(filter.searchText != null ? filter.searchText : '');
    } else {
      setMin(null);
      setMax(null);
      setSearchText('');
    }
  }

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div
        role="presentation"
        style={{
          padding: 8,
          minWidth: 220,
          maxWidth: 'min(100vw - 48px, 320px)',
          boxSizing: 'border-box',
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className="export-filter-dropdown-title">Search Text</div>
        <OnTraccrTextInput
          style={{ marginBottom: 8 }}
          allowClear
          placeholder="Search"
          value={searchText}
          onChange={onSearchTextChange}
        />
        <div className="export-filter-dropdown-title">Greater Than or Equal To</div>
        <OnTraccrNumberInput
          style={{ marginBottom: 8 }}
          placeholder="Enter a number"
          value={min}
          onChange={onMinChange}
          onKeyDown={(e) => e.stopPropagation()}
        />
        <div className="export-filter-dropdown-title">Less Than or Equal To</div>
        <OnTraccrNumberInput
          style={{ marginBottom: 8 }}
          placeholder="Enter a number"
          value={max}
          onChange={onMaxChange}
          onKeyDown={(e) => e.stopPropagation()}
        />
        <Divider style={{ margin: 0 }} />
        <CustomExportFilterDropdownFooter onReset={reset} onApply={applyFilter} />
      </div>
    </>
  );
}

CustomExportNumberRangeFilterDropdown.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  setSelectedKeys: PropTypes.func.isRequired,
  visible: PropTypes.bool,
};

CustomExportNumberRangeFilterDropdown.defaultProps = {
  selectedKeys: [],
  visible: false,
};
